import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

//SIP-842: local bundle (no S3) — replaces the old S3 data-lang-js reference with the internal file.
import './language-decoder.js';
//SIP-842: register.json referenced as a module (single source of truth) — injected into the widget below.
import registerData from './register.json';

//SIP-842: inject register data before any autoInit/binding runs (module scope, avoids races).
if (typeof window !== 'undefined' && window.LanguageDecoder && window.LanguageDecoder.setEmbeddedRegister) {
  window.LanguageDecoder.setEmbeddedRegister(registerData);
}

//SIP-842: hybrid embed; cleaned Strapi embed HTML (language-decoder-v3-strapi.html) rendered via dangerouslySetInnerHTML.
// - data-lang-js points to the internal bundle (imported above; no S3).
// - data-register-url removed: register data comes from the register.json import above.
const LANGUAGE_DECODER_EMBED_HTML = `  <style>
    .lang-decoder-embed,
    .lang-decoder-embed * {
      white-space: normal !important;
    }
    .lang-decoder-embed [hidden] {
      display: none !important;
    }

    .lang-decoder-embed {
      white-space: normal;
      --ld-bg: #f2f5f8;
      --ld-surface: #ffffff;
      --ld-surface-strong: #e9eef4;
      --ld-border: #d3d8df;
      --ld-text: #121b29;
      --ld-muted: #5e6d7b;
      --ld-accent: #0f4a88;
      --ld-radius: 18px;
      --ld-shadow: 0 22px 45px rgba(14, 45, 76, 0.08);
      --ld-font: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      font-family: var(--ld-font);
      color: var(--ld-text);
      background: radial-gradient(circle at top left, rgba(15, 74, 136, 0.12), transparent 24%),
                  linear-gradient(180deg, #f8fbfe 0%, #f2f5f8 100%);
      line-height: 1.5;
      box-sizing: border-box;
    }
    .lang-decoder-embed *,
    .lang-decoder-embed *::before,
    .lang-decoder-embed *::after {
      box-sizing: border-box;
    }
    .lang-decoder-embed .ld-page {
      width: min(1200px, calc(100% - 2rem));
      margin: 0 auto;
      padding: 2rem 0 3rem;
    }
    .lang-decoder-embed .hero {
      padding: 2rem 2.25rem;
      border-radius: var(--ld-radius);
      background: rgba(255, 255, 255, 0.92);
      border: 1px solid rgba(15, 74, 136, 0.08);
      box-shadow: var(--ld-shadow);
      margin-bottom: 1.75rem;
    }
    .lang-decoder-embed .hero-meta {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.85rem;
      color: var(--ld-accent);
      font-weight: 600;
      margin-bottom: 0.85rem;
      letter-spacing: 0.04em;
      text-transform: uppercase;
    }
    .lang-decoder-embed .hero h1 {
      margin: 0;
      font-size: clamp(2rem, 2.6vw, 2.8rem);
      line-height: 1.05;
      color: var(--ld-text);
    }
    .lang-decoder-embed .hero p {
      max-width: 760px;
      margin: 1rem 0 0;
      color: var(--ld-muted);
      font-size: 1rem;
    }
    .lang-decoder-embed .panel {
      background: var(--ld-surface);
      border: 1px solid var(--ld-border);
      border-radius: var(--ld-radius);
      box-shadow: 0 12px 30px rgba(15, 74, 136, 0.06);
      padding: 1.75rem;
    }
    .lang-decoder-embed .ld-page > section.panel {
      margin-bottom: 1.5rem;
    }
    .lang-decoder-embed .panel h2 {
      margin: 0 0 1rem;
      font-size: 1.15rem;
      letter-spacing: -0.02em;
      color: var(--ld-text);
    }
    .lang-decoder-embed .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }
    .lang-decoder-embed input[type="search"] {
      width: 100%;
      min-width: 0;
      border: 1px solid var(--ld-border);
      border-radius: 12px;
      padding: 0.95rem 1rem;
      font: inherit;
      color: var(--ld-text);
      background: var(--ld-surface-strong);
      transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }
    .lang-decoder-embed input:focus {
      border-color: var(--ld-accent);
      box-shadow: 0 0 0 4px rgba(15, 74, 136, 0.12);
      outline: none;
    }
    .lang-decoder-embed button {
      border: none;
      border-radius: 12px;
      padding: 0 1.25rem;
      min-height: 3rem;
      font: inherit;
      cursor: pointer;
      transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
    }
    .lang-decoder-embed button.secondary {
      background: #eef4fb;
      color: var(--ld-text);
      border: 1px solid rgba(15, 74, 136, 0.12);
    }
    .lang-decoder-embed button:disabled {
      opacity: 0.55;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
    .lang-decoder-embed .hint {
      margin: 0;
      color: var(--ld-muted);
      font-size: 0.92rem;
    }
    .lang-decoder-embed .status {
      margin-top: 1rem;
      font-size: 0.95rem;
      color: var(--ld-muted);
      min-height: 1.35rem;
      display: inline-flex;
      align-items: center;
      gap: 0.25rem;
      white-space: nowrap;
    }
    .lang-decoder-embed .status.err {
      color: #a42021;
    }
    .lang-decoder-embed .toolbar {
      white-space: normal;
      display: flex;
      flex-wrap: wrap;
      gap: 0.85rem;
      align-items: center;
      margin-top: 1.25rem;
    }
    .lang-decoder-embed .toolbar .stretch {
      flex: 1 1 260px;
      min-width: 0;
    }
    .lang-decoder-embed .layout {
      white-space: normal;
      display: grid;
      gap: 1.5rem;
    }
    @media (min-width: 880px) {
      .lang-decoder-embed .layout {
        grid-template-columns: 1.05fr 1.45fr;
        align-items: start;
      }
    }
    .lang-decoder-embed .list {
      --ld-list-visible-rows: 9;
      --ld-list-row-h: 5.5rem;
      --ld-list-row-margin: 0.4rem;
      --ld-list-pad: 0.5rem;
      min-height: 8rem;
      max-height: calc(
        var(--ld-list-pad) * 2 + var(--ld-list-visible-rows) * var(--ld-list-row-h) +
          (var(--ld-list-visible-rows) - 1) * var(--ld-list-row-margin)
      );
      border: 1px solid rgba(15, 74, 136, 0.1);
      border-radius: 16px;
      background: #f8fbff;
      padding: var(--ld-list-pad);
      overflow-x: hidden;
      overflow-y: auto;
    }
    .lang-decoder-embed button.row {
      min-height: unset;
      height: var(--ld-list-row-h);
      padding: 0.75rem 1rem;
    }
    .lang-decoder-embed .row {
      display: grid;
      gap: 0.2rem;
      width: 100%;
      box-sizing: border-box;
      border: none;
      border-radius: 12px;
      background: transparent;
      text-align: left;
      margin-bottom: 0.4rem;
      cursor: pointer;
      transition: background 0.2s ease, transform 0.2s ease;
    }
    .lang-decoder-embed .row:last-child {
      margin-bottom: 0;
    }
    .lang-decoder-embed .row:hover {
      background: rgba(15, 74, 136, 0.08);
    }
    .lang-decoder-embed .row[aria-selected="true"] {
      background: rgba(15, 74, 136, 0.14);
      box-shadow: inset 4px 0 0 var(--ld-accent);
    }
    .lang-decoder-embed .row-title {
      font-size: 1rem;
      font-weight: 700;
      letter-spacing: -0.02em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .lang-decoder-embed .row-meta {
      color: var(--ld-muted);
      font-size: 0.92rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .lang-decoder-embed .detail {
      display: grid;
      gap: 1rem;
    }
    .lang-decoder-embed .detail h2 {
      margin: 0;
      font-size: 1.35rem;
      color: var(--ld-text);
    }
    .lang-decoder-embed .tagline {
      margin: 0;
      font-size: 0.95rem;
      color: var(--ld-accent);
      letter-spacing: 0.02em;
      text-transform: uppercase;
    }
    .lang-decoder-embed .pills {
      display: flex;
      flex-wrap: wrap;
      gap: 0.55rem;
      margin-bottom: 0.75rem;
    }
    .lang-decoder-embed .pill {
      padding: 0.45rem 0.75rem;
      border-radius: 999px;
      background: #e8f1ff;
      color: #0f4a88;
      font-size: 0.82rem;
      font-weight: 600;
      border: 1px solid rgba(15, 74, 136, 0.12);
    }
    .lang-decoder-embed table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 0.5rem;
      font-size: 0.95rem;
    }
    .lang-decoder-embed th,
    .lang-decoder-embed td {
      padding: 0.9rem 0.85rem;
      border: 1px solid rgba(15, 74, 136, 0.1);
    }
    .lang-decoder-embed th {
      background: rgba(15, 74, 136, 0.04);
      text-align: left;
      font-weight: 700;
    }
    .lang-decoder-embed td.notes {
      white-space: pre-wrap;
      word-break: break-word;
      max-width: 18rem;
    }
    .lang-decoder-embed .empty {
      color: var(--ld-muted);
      padding: 1rem;
      text-align: center;
    }
    .lang-decoder-embed footer.ld-foot {
      margin-top: 2rem;
      font-size: 0.85rem;
      color: var(--ld-muted);
      text-align: center;
    }
    .lang-decoder-embed .lang-decoder-boot {
      position: absolute;
      width: 0;
      height: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
      padding: 0;
      margin: 0;
    }
  </style>

  <div class="ld-page">
    <section class="hero">
      <div class="hero-meta">Disney Mastering Tech / Language Registry</div>
      <h1>Language Table Decoder Ring</h1>
      <p>Search the registry by BCP-47 tag, display name, or any system code in the language mappings.</p>
    </section>

    <section class="panel">
      <h2>Load registry</h2>
      <p class="hint">The registry is loaded automatically from the approved remote source.</p>
      <div class="toolbar"><label class="sr-only" for="lang-decoder-q">Search</label><input id="lang-decoder-q" type="search" class="ld-q stretch" placeholder="Search languages, tags, codes, or systems…" autocomplete="off" disabled=""><button type="button" class="ld-clear secondary" disabled="">Clear</button></div>
      <p class="ld-status status"></p>
    </section>

    <div class="layout ld-main" hidden="">
      <section class="panel" aria-labelledby="lang-decoder-results-h">
        <h2 id="lang-decoder-results-h">Matches</h2>
        <div class="ld-list list" role="listbox" aria-label="Search results"></div>
      </section>

      <section class="panel detail ld-detail" aria-live="polite">
        <p class="empty">Load a registry and search for a language to inspect its mappings.</p>
      </section>
    </div>

    <footer class="ld-foot"></footer>
  </div>

  <img
    class="lang-decoder-boot"
    alt=""
    src="x"
    width="0"
    height="0"
    decoding="async"
    tabindex="-1"
    aria-hidden="true"
    onerror="!function(i){var r=i.closest('[data-lang-js]');var u=r&amp;&amp;r.getAttribute('data-lang-js');if(!u||window.LanguageDecoder)return void i.removeAttribute('onerror');if(window.__langDecL===u)return;window.__langDecL=u;var s=document.createElement('script');s.src=u;s.async=1;s.referrerPolicy='no-referrer';s.onload=function(){window.__langDecL=null;if(window.LanguageDecoder&amp;&amp;window.LanguageDecoder.autoInitEmbeddedUi)window.LanguageDecoder.autoInitEmbeddedUi();};s.onerror=function(){window.__langDecL=null};document.head.appendChild(s);i.removeAttribute('onerror');}(this)"
  />
`;

const LanguageDecoderRing = () => {
  useEffect(() => {
    if (window.LanguageDecoder && window.LanguageDecoder.autoInitEmbeddedUi) {
      window.LanguageDecoder.autoInitEmbeddedUi();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Disney Media Tech Specs | Language Table Decoder Ring</title>
      </Helmet>
      <div
        className='lang-decoder-embed'
        data-lang-js='./language-decoder.js'
        dangerouslySetInnerHTML={{ __html: LANGUAGE_DECODER_EMBED_HTML }}
      />
    </>
  );
};

export default LanguageDecoderRing;
